import DocPage from '../components/DocPage.jsx'
import { commands, docsCards, featureCommandItems } from '../content.js'

// /docs/cards — P6-305. The last live feature that had no page: `cards` sat in
// src/test/documentation.test.jsx's NOT_YET_PAGED from the day that gate was
// written until this page.
//
// Four lines for the page itself, like every sibling — content-src/docs-
// cards.json carries the prose, this component only wires it to the shared
// page type (see DocsMovieNight.jsx for why that is the whole return on
// components/DocPage.jsx) — PLUS the one generated piece DR2 asks every
// feature page to carry: "its commands (generated, §3)."
//
// 🔴 THE COMMAND BLOCK IS GENERATED HERE, THE SAME WAY DocsWatch.jsx DOES IT,
// AND FOR THE SAME REASONS: not in content-src/docs-cards.json (the JSON
// carries no command list at all, so a renamed or newly registered /cards
// command needs no edit to it), and not in scripts/generate-content.mjs
// (teaching the SHARED generator a per-page feature filter would make every
// sibling page opt out of a shape only a few pages use).
//
// The filter is content.js's `featureCommandItems`, shared with DocsWatch.jsx.
// P6-305 wrote this page's own copy of it because DocsWatch.jsx was not that
// lane's to edit, and recorded the cost; P6-312 lifted the two into one. The
// feature name is the only thing this page supplies, and src/test/
// documentation.test.jsx holds both pages to an independently built reference.
const doc = {
  ...docsCards,
  sections: docsCards.sections.map((section) =>
    section.id === 'commands'
      ? { ...section, items: featureCommandItems(commands.commands, 'cards') }
      : section,
  ),
}

export default function DocsCards() {
  return <DocPage doc={doc} />
}
